// 异样处理页面
import NoAuthority from '_src/pages/exception/NoAuthority'
import NoFound from '_src/pages/exception/NoFound'
import ServerError from '_src/pages/exception/ServerError'

// 首页
import Home from '_src/pages/home/home'
//电子登记簿
import ElectronicRegister from '_src/pages/ElectronicRegister'
//出金申请
import WithdrawApply from '_src/pages/withdrawApply'
//自动提现申请
import AutoWithdraw from '_src/pages/autoWithdraw'
//收款方待结算交易明细查询
import TransactionDetails from '_src/pages/transactionDetails'
//电子登记簿回调页面
import Result from '_src/pages/result'
//自动提现授权回调
import AuthorizeResult from '_src/pages/authorizeResult'


const routers = [
	{
		path: '/home',
		exact: true,
		component: Home,
	},
	{
		path: '/elect',
		exact: true,
		component: ElectronicRegister,
	},
	{
		path: '/withdraw',
		exact: true,
		component: WithdrawApply,
	},
	{
		path: '/AutoWithdraw',
		exact: true,
		component: AutoWithdraw,
	},
	{
		path: '/result',
		exact: true,
		component: Result,
	},
	{
		path: '/authorizeResult',
		exact: true,
		component: AuthorizeResult,
	}
]

const initRoutes = [
	{
		path: '/403',
		exact: true,
		component: NoAuthority,
		unauthorized: true
	},
	{
		path: '/404',
		exact: true,
		component: NoFound,
		unauthorized: true
	},
	{
		path: '/500',
		exact: true,
		component: ServerError,
		unauthorized: true
	}
]

export default [...routers, ...initRoutes]